<template>
  <FormKit
    id="details-form"
    v-model="values"
    #="{ state: { valid } }"
    type="form"
    form-class="grid devis-form"
    :actions="false"
    :incomplete-message="false"
  >
    <FormKit
      id="contactCivility"
      type="text"
      name="contactCivility"
      outer-class="g-col-12 g-col-lg-6 required"
      validation="required"
      :label="__('Civility:', 'smdt')"
      :placeholder="__('Civility:', 'smdt')"
      :value="values.contactCivility"
    />
    <FormKit
      id="contactFirstName"
      type="text"
      name="contactFirstName"
      outer-class="g-col-12 g-col-lg-6 required"
      validation="required"
      :label="__('First name:', 'smdt')"
      :placeholder="__('First name:', 'smdt')"
      :value="values.contactFirstName"
    />
    <FormKit
      id="contactLastName"
      type="text"
      name="contactLastName"
      outer-class="g-col-12 g-col-lg-6 required"
      validation="required"
      :label="__('Last name:', 'smdt')"
      :placeholder="__('Last name:', 'smdt')"
      :value="values.contactLastName"
    />
    <FormKit
      id="contactEmail"
      type="email"
      name="contactEmail"
      outer-class="g-col-12 g-col-lg-6 required"
      validation="required|email"
      :label="__('Email:', 'smdt')"
      :placeholder="__('Email:', 'smdt')"
      :value="values.contactEmail"
    />
    <FormKit
      id="contactHomePhone"
      type="text"
      name="contactHomePhone"
      outer-class="g-col-12 g-col-lg-6 required"
      validation="required"
      :label="__('Home phone:', 'smdt')"
      placeholder="+33 0x xx xx xx xx"
      :value="values.contactHomePhone"
    />
    <FormKit
      id="contactBusinessPhone"
      type="text"
      name="contactBusinessPhone"
      outer-class="g-col-12 g-col-lg-6"
      :label="__('Business phone:', 'smdt')"
      placeholder="+33 0x xx xx xx xx"
      :value="values.contactBusinessPhone"
    />
    <FormKit
      id="contactInformation"
      type="textarea"
      name="contactInformation"
      outer-class="g-col-12"
      :label="__('Further information:', 'smdt')"
      :placeholder="__('Further information:', 'smdt')"
      :value="values.contactInformation"
    />
    <!-- eslint-disable -->
    <div class="g-col-12">
      <div class="devis-btn-group">
        <button
          type="button"
          class="devis-btn devis-btn--white"
          @click="goStep(4)"
        >
          {{ __('Previous step', 'smdt') }}
        </button>
        <button
          type="button"
          class="devis-btn"
          :disabled="!canNext"
          @click="goStep(6)"
        >
          {{ __('Next step', 'smdt') }}
        </button>
      </div>
    </div>
  </FormKit>
</template>

<script>
import { mapActions, mapState, mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'
import { watch } from 'vue'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

export default {
  name: 'StageSix',
  props: {
    stage: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapWritableState(useStagesStore, ['values', 'ajaxLoading']),
    ...mapState(useStagesStore, ['inventories', 'canNext']),
    canSubmit() {
      if (!this.values.startPostalCode || !this.values.startCity) {
        return 1
      }

      if (!this.values.destPostalCode || !this.values.destCity) {
        return 2
      }

      if (!this.values.moveDate) {
        return 3
      }

      const sum = this.inventories.reduce((acc, cur) => {
        return acc + cur.size * 1 * cur.count
      }, 0)

      if (!sum > 0 && !this.values.moveMeter) {
        return 4
      }

      if (!this.values.offer) {
        return 5
      }

      return true
    },
  },
  mounted() {
    const node = this.$formkit.get('details-form')
    const isValid = node.context.state

    watch(isValid, (val) => {
      const { valid } = val
      this.setValid(valid)
    })
  },
  methods: {
    ...mapActions(useStagesStore, ['setValid', 'goStep', 'reset']),
    __,
  },
}
</script>

<style scoped lang="scss"></style>
